import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import Modal from '../../components/Modal';
import Manipulator from '../../utils/dom/manipulator';
import Request from '../../utils/request';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';

class EditBiography {
	constructor() {
		this.status = undefined;
		this.biography = '';
		this._container = SelectorEngine.findOne('.js-edit-coach-details-biography');

		if (this._container) {
			this.init();
		}
	}

	init() {
		this._exitModal = new Modal(SelectorEngine.findOne('#coach-details-biography-exit'), {});

		this._cancelCta = SelectorEngine.findOne('.lta-coach-details__edit-biography-back');
		this._cancelCta.addEventListener('click', () => this._exitModal.show());

		const popupCancel = SelectorEngine.findOne('.lta-coach-details__edit-biography-continue');
		popupCancel.addEventListener('click', () => this._exitModal.hide());

		const popupContinue = SelectorEngine.findOne('.lta-coach-details__edit-biography-exit');
		popupContinue.addEventListener('click', (event) => this.backToUrl(event));

		const biography = SelectorEngine.findOne('.js-biography-text', this._container);

		if (biography.textContent.length > 0) {
			this.biography = biography.textContent;
		}

		EventHandler.on(biography, 'change', (event) => {
			this.handleTextAreaInputChange(event);
		});

		this.validationWrapper = SelectorEngine.findOne('.validation-wrapper', this._container);
		this._validationErrorText = SelectorEngine.findOne('.lta-text-input--error', this._container);

		this.hideBiography = SelectorEngine.findOne('.hide-biography', this._container);
		const initialStatus = this.hideBiography.querySelector('.lta-toggle--checkbox').checked;
		this.status = initialStatus ? initialStatus : false;

		this._errorContainer = SelectorEngine.findOne('.lta-edit-biography-error-container', this._container);
		this._errorText = SelectorEngine.findOne('.error-text', this._errorContainer);
		this._closeErrorSnackBar = SelectorEngine.findOne('.js-dismiss-error', this._errorContainer);

		this._closeErrorSnackBar.addEventListener('click', () => {
			this._errorContainer.classList.add('u-hidden');
		});

		this._saveCta = SelectorEngine.findOne('.save-biography-cta', this._container);
		this._saveCta.addEventListener('click', (event) => {
			this.triggerSubmit(event);
		});

		EventHandler.on(window, 'toggleStatus', (event) => {
			this.status = event.detail.status;
		});
	}

	handleTextAreaInputChange(event) {
		this._validationErrorText.textContent = '';
		this.validationWrapper.classList.remove('validation-error');
		this.biography = event.target.value;
	}

	async triggerSubmit(event) {
		event.preventDefault();
		if (this.biography.length === 0) {
			this._validationErrorText.textContent = 'Please input your biography';
			this.validationWrapper.classList.add('validation-error');
			return;
		}
		const payload = {
			updateCoachDetailsRequest: {
				myBiography: {
					coachBiography: this.biography,
					biographyVisibility: this.status
				}
			}
		};
		startLoadingAnimation(true);
		try {
			const url = `/api/coachdetails/update`;
			const responseData = await Request.post(url, payload);

			const { success } = responseData;
			if (success) {
				const redirectUrl = Manipulator.getDataAttribute(this._container, 'redirect-url');
				window.location.href = redirectUrl;
			} else {
				this._errorContainer.classList.remove('u-hidden');
				this._errorText.innerHTML = Manipulator.getDataAttribute(this._container, 'api-failed-error');
			}
		} catch {
			this._errorContainer.classList.remove('u-hidden');
			this._errorText.innerHTML = Manipulator.getDataAttribute(this._container, 'api-failed-error');
			this._errorContainer.scrollIntoView();
		} finally {
			stopLoadingAnimation();
		}
	}

	backToUrl(event, redirectUrl) {
		const rootUrl = window.location.origin;
		const url = redirectUrl || event.currentTarget.dataset.target;
		window.location.href = `${rootUrl}${url}`;
	}
}

const globalEditBiography = new EditBiography();

export default globalEditBiography;
